import React, { useEffect, useState } from "react"
import LoadingSpinner from "../../../shared/components/ui/LoadingSpinner"
import API from "../../../apis/contextmeeting/api"
import { withAuthHeader } from "../../../apis/contextmeeting/withAuthHeader"
import Button from "../../../shared/components/buttons/Button"
import { useTranslation } from "react-i18next"
import { StyleVariants } from "../../../shared/state/sharedTypes"

interface Props {
  formTemplateId: string
  onBack: () => void
}

const FormTemplatePreview: React.FC<Props> = ({ formTemplateId, onBack }) => {
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)
  const { t } = useTranslation(["forms"])

  useEffect(() => {
    API.get(`/form_templates/${formTemplateId}/preview`, withAuthHeader())
      .then(res => setPreviewUrl(res.data.location))
  }, [formTemplateId])

  if (!previewUrl) return <LoadingSpinner />

  return (
    <div className="flex flex-col space-y-4">
      <div className="flex justify-end">
        <Button
          action={onBack}
          variant={StyleVariants.BLUE_ALT}
        >
          {t("forms:addFormToCase:buttons:back")}
        </Button>
      </div>
      <div className="flex-1 border border-ch-gray-400 rounded-md p-4">
        <iframe src={previewUrl} className="w-full h-96" />
      </div>
    </div>
  )
}

export default FormTemplatePreview
